import styled from 'styled-components';

const widthBig = 500;
const widthSmall = 300;

export const StyledFloatingCard = styled.div`
  width: ${widthBig}px;
  height: ${widthBig * 0.7}px;
  border-radius: 10px;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${(props) => props.url}) no-repeat center center / cover;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.5s;
  will-change: transform;
  border: 10px solid white;
  cursor: pointer;
  user-select: none;
  
&:hover {
  box-shadow: 0 30px 100px -10px rgba(0, 0, 0, 0.4);
}
  
  @media only screen and (max-width: 1160px) {
  width: ${widthSmall}px;
  height: ${widthSmall * 0.7}px;
  }
  
  @media only screen and (max-width: 800px) {
  margin: 25px 0;
  }
`;


export const StyledFloatingTitleCard = styled.h1`
color: #eaca81;
font-size: 50px;
text-align: center;
text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;

  @media only screen and (max-width: 1160px) {
    font-size: 30px;
  }
`;
